import { http } from "@/http/axios.js";

// 列表
export function getListAPI(params) {
  return http({
    url: "/admin/finance/order/reserve/page",
    method: "get",
    params,
  });
}
